<ngx-spinner [name]="'solicitacoes-cadastro'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Solicitações de cadastro</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content *ngIf="!bConsulta">

        <div class="row">
            <div class="col-sm-6">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Filtro</mat-label>
                    <input matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro">
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <table mat-table [dataSource]="solicitacoesCadastroSource" class="mat-elevation-z2"
                    style="width: 100%;">

                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Nome </th>
                        <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Email">
                        <th mat-header-cell *matHeaderCellDef> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Telefone">
                        <th mat-header-cell *matHeaderCellDef> Telefone </th>
                        <td mat-cell *matCellDef="let element"> {{element.Telefone}} </td>
                    </ng-container>

                    <ng-container matColumnDef="CPFCNPJ">
                        <th mat-header-cell *matHeaderCellDef> CPF / CNPJ </th>
                        <td mat-cell *matCellDef="let element"> {{element.CPFCNPJ}} </td>
                    </ng-container>

                    <ng-container matColumnDef="DataHoraSolicitacao">
                        <th mat-header-cell *matHeaderCellDef> Data e Hora </th>
                        <td mat-cell *matCellDef="let element"> {{element.DataHoraSolicitacao}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Cidade">
                        <th mat-header-cell *matHeaderCellDef> Cidade </th>
                        <td mat-cell *matCellDef="let element"> {{element.Cidade}} </td>
                    </ng-container>

                    <ng-container matColumnDef="sVisualizada">
                        <th mat-header-cell *matHeaderCellDef> Visualizada </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="retangulo_tabela" [ngStyle]="{'background': (element.sVisualizada=='Sim') ? '#42D697' : '#FE696A'}">
                                {{element.sVisualizada}}</div>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="Consultar">
                        <th mat-header-cell *matHeaderCellDef> Consultar </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Detalhar solicitação de cadastro" (click)="consultarSolicitacao(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Expandir">search</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="consultarSolicitacao(row)"></tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6" style="text-align: center;">Não há solicitações de cadastro
                            cadastrados no sistema ou com o filtro definido
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
            </div>
        </div>
    </mat-card-content>

    <mat-card-content *ngIf="bConsulta">

        <form [formGroup]="solicitacaoCadastroForm">
            <div class="row">

                <div class="col-sm text-right mr-2">
                    Solicitado dia: <strong>{{f.dataHoraSolicitacao.value}}</strong>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Informações Gerais</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Nome</mat-label>
                            <input type="text" matInput formControlName="nome" required maxlength="100">
                        </mat-form-field>
                    </div>

                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Telefone</mat-label>
                            <input type="text" matInput formControlName="telefone" required maxlength="100">
                        </mat-form-field>
                    </div>

                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>E-mail</mat-label>
                            <input type="text" matInput formControlName="email" required maxlength="100">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-3" *ngIf="f.tipoCadastro.value === 'CNPJ'">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>CNPJ</mat-label>
                            <input type="text" matInput formControlName="cnpj" required>
                        </mat-form-field>
                    </div>

                    <div class="col-2" *ngIf="f.tipoCadastro.value === 'CPF'">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>CPF</mat-label>
                            <input type="text" matInput formControlName="cpf" required>
                        </mat-form-field>
                    </div>

                    <div class="col-2">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>UF</mat-label>
                            <input type="text" matInput formControlName="uf" required>
                        </mat-form-field>
                    </div>

                    <div class="col-auto" >
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Cidade</mat-label>
                            <input type="text" matInput formControlName="cidade" required>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Observação</mat-label>
                            <textarea type="text" matInput formControlName="observacao" maxlength="100"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </form>

        <div class="row mt-4">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
                    <button mat-flat-button color="warn" (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon> Voltar
                    </button>
                    <button *ngIf="!f.bVisualizada.value" mat-flat-button color="primary" (click)="atualizar()">
                        <mat-icon>check</mat-icon> Marcar como vista
                    </button>
                </section>
            </div>
        </div>
    </mat-card-content>
</mat-card>
